export const name = 'ukeybox-api-config'
const prefix = '/api/v2/agent'
export const api = {
  reim: {
    getReimList: `${prefix}/purchaser/reim/page`, // post 获取报销列表
    getReimInfo: `${prefix}/purchaser/reim/detail`, // post 获取报销详细信息
    addOrEditReim: `${prefix}/purchaser/mobile/reim/saveOrUpdate`, // post 修改或保存报销单
    delReimById: `${prefix}/purchaser/reim/delete`, // get 删除报销单
    getExamineInfo: `/api/v2/bud/approvalFlow/instance/wait/info`, // post查询审批流详情
    examine: '/api/v2/bud/approvalFlow/instance/wait/examine', // POST 驳回或通过
    getExaminePage: `/api/v2/bud/approvalFlow/instance/wait/page` // POST查询审批流列表
  }
}
